import axios from "../../../../../../../api/axiosInstance";
import {
  PatchEventNotificationRequest,
  PatchEventNotificationResponse,
} from "./types";

export const patchEventNotification = async (
  id: number,
  data: PatchEventNotificationRequest,
): Promise<PatchEventNotificationResponse> => {
  const response = await axios.patch<PatchEventNotificationResponse>(
    `/api/private/administration/events/notifications/${id}`,
    data,
  );

  return response.data;
};
